import React from 'react';

function MasterCardIcon() {
  return (
    <svg
      width="38"
      height="29"
      viewBox="0 0 38 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9783 26.8789C18.5937 26.8789 23.9565 21.5063 23.9565 14.8789C23.9565 8.25149 18.5937 2.87891 11.9783 2.87891C5.36285 2.87891 0 8.25149 0 14.8789C0 21.5063 5.36285 26.8789 11.9783 26.8789Z"
        fill="#FF0000"
      />
      <path
        d="M26.0217 26.8789C32.6371 26.8789 38 21.5063 38 14.8789C38 8.25149 32.6371 2.87891 26.0217 2.87891C19.4063 2.87891 14.0435 8.25149 14.0435 14.8789C14.0435 21.5063 19.4063 26.8789 26.0217 26.8789Z"
        fill="#FF9900"
      />
      <path
        d="M23.9565 14.8789C23.9565 10.8368 21.9739 7.29998 19 5.27893C16.0261 7.4684 14.0435 11.0052 14.0435 14.8789C14.0435 18.7526 16.0261 22.4579 19 24.4789C21.9739 22.4579 23.9565 18.921 23.9565 14.8789Z"
        fill="#FF4F00"
      />
    </svg>
  );
}

export default MasterCardIcon;
